var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{attrs:{"color":"primary","small":""},on:{"click":function($event){return _vm.deleteNotes()}}},[_vm._v("Delete")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }